import {loadTopics} from 'src/pages/category/store/actions/topics';
import {authenticate} from 'src/shared/auth/actions';
import {
  datacast,
  READ_DATACAST_COMPLETE,
} from 'src/shared/datacast/actions';
import {hasProactiveIssueDetectionSegment} from 'src/shared/datacast/selectors';
import {startDataLayerTracking} from 'src/shared/dataLayer/actions';
import {waitUntil} from 'src/shared/events';
import {preloadItgRecommendations} from 'src/shared/itgRecommendations/actions';
import {loadUser} from 'src/shared/user/actions';

export const startPage = () => async (dispatch, getState) => {
  dispatch(loadTopics());
  dispatch(authenticate());
  dispatch(loadUser());
  dispatch(startDataLayerTracking());
  dispatch(datacast());
  await waitUntil(READ_DATACAST_COMPLETE);
  if (hasProactiveIssueDetectionSegment(getState())) {
    dispatch(preloadItgRecommendations());
  }
};
